import { useState, useRef } from 'react';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup_portal';
import FindCGWordPopup from "@/pages/comp/plan/todo/popup/find_cg_word";
import SelectCGWordArrPopup from "@/pages/comp/book_order/textbook/popup/select_cg_word_arr";
import TodoContentRow from "./row";

function TodoContent(props: any) {
  let myProps = {
    todo_data_arr: [],
    set_todo_data_arr: (inData: any) => { },
    default_todo_data: {},
    Style: {},
    ...props
  };
  let Style = myProps.Style;
  let todo_data_arr = myProps.todo_data_arr;
  let default_todo_data = myProps.default_todo_data;

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "find_study",//find_study,find_video,find_textbook
    title: "교재찾기",
    s_use_sort: "study",//procedure
    listOpt: {},
    cg_word_arr: [],
    cg_word_pri_val_arr: [],
    select_cg_word_pri_val_arr: [],
    todo_data_row_num:-1,
    width: "1000px",
    height: "100%",
  });

  const open_find_textbook_popup = (inData: any) => {
    let opt_obj = {
      par_sort: "mtextbook",//word_inside
      ...inData
    };

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "find_cg_word",
      title: "온라인학습단어",
      par_sort: opt_obj.par_sort,
      listOpt: {
        s_subject: default_todo_data.a_subject,
        s_is_able_order: "empty",
        s_addon_study_word: "1",
        s_use_sort: "study_word",
      },
    });
  };

  const callback_find_textbook = (inData: any) => {
    let opt_obj = {
      "info_arr": [],
      ...inData
    };
    let all_row: any = [...todo_data_arr];
    for (let i = 0; i < opt_obj["info_arr"].length; i++) {
      let row_info = opt_obj["info_arr"][i];
      let row_word_cnt = 0;
      let row_cg_word_arr: any = [];
      if (row_info.study_arr) {
        for (let s_i = 0; s_i < row_info.study_arr.length; s_i++) {
          let study_row = row_info.study_arr[s_i];
          if (study_row.cg_word_arr) {
            row_word_cnt += study_row.cg_word_arr.length;
            row_cg_word_arr = [
              ...row_cg_word_arr,
              ...study_row.cg_word_arr
            ];
          }
        }
      }

      if (row_info.cg_word_arr) {
        row_word_cnt += row_info.cg_word_arr.length;
        row_cg_word_arr = [
          ...row_cg_word_arr,
          ...row_info.cg_word_arr
        ];
      }
      let row_subject = "";
      let row_par_id = popupData.par_sort;
      let row_par_seq = row_info["a_seq"];
      if (row_par_id == "mtextbook") {
        row_subject = row_info["a_subject"];
      } else if (row_par_id == "word_inside") {
        row_subject = "영어";
      }

      let add_row_data: any = {
        ...default_todo_data,
        // "a_sort": "study",
        "a_sort_det": "cg_word",
        "a_subject": row_subject,
        "a_title": row_info["a_title"],
        "a_content": "",
        "a_success_sort": "amount",
        "a_par_id": row_par_id,
        "a_par_seq": row_par_seq,
        "a_success_time_sec": 0,
        "a_success_amount": row_word_cnt,
        "a_amount_sort": "개",
        "row_view_success_amount": row_word_cnt,
        "cg_word_arr": row_cg_word_arr
      };
      all_row.push(add_row_data);
    }
    myProps.set_todo_data_arr(all_row);
  };

  const add_todo_content_row = () => {
    let tmp_todo_data_arr = [...todo_data_arr];
    let new_todo_data = { ...default_todo_data };
    if (tmp_todo_data_arr.length > 0) {
      let last_row = tmp_todo_data_arr[tmp_todo_data_arr.length - 1];
      new_todo_data = { ...last_row };
    }
    tmp_todo_data_arr.push(new_todo_data);
    myProps.set_todo_data_arr(tmp_todo_data_arr);
  };

  const delete_todo_content_row = (row_num: number) => {
    let tmp_todo_data_arr = [];
    for (let i = 0; i < todo_data_arr.length; i++) {
      if (i != row_num) {
        tmp_todo_data_arr.push(todo_data_arr[i]);
      }
    }
    myProps.set_todo_data_arr(tmp_todo_data_arr);
  };

  const open_select_cg_word_arr_popup = (inData: any) => {
    let opt_obj = {
      row_num:-1,
      todo_data:null,
      ...inData
    };
    let todo_data:any=opt_obj.todo_data;
    let tmp_cg_word_arr: any = [];
    let cg_word_pri_val_arr = [];
    let select_cg_word_pri_val_arr = [];
    if(todo_data&&todo_data.cg_word_arr){
      tmp_cg_word_arr= todo_data.cg_word_arr;
      for(let i=0;i<todo_data.cg_word_arr.length;i++){
        let cg_word = todo_data.cg_word_arr[i];
        cg_word_pri_val_arr.push(cg_word.row_pri_val);
      }
    }
    if(todo_data&&todo_data.cg_word_custom_arr){
      tmp_cg_word_arr= todo_data.cg_word_custom_arr;
      for(let i=0;i<todo_data.cg_word_custom_arr.length;i++){
        let cg_word = todo_data.cg_word_custom_arr[i];
        select_cg_word_pri_val_arr.push(cg_word.row_pri_val);
      }
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "select_cg_word_arr",
      title:"단어선택",
      cg_word_arr:tmp_cg_word_arr,
      cg_word_pri_val_arr: cg_word_pri_val_arr,
      select_cg_word_pri_val_arr: select_cg_word_pri_val_arr,
      todo_data_row_num:opt_obj.row_num,
    });
  };

  const callback_select_cg_word_arr = (inData: any) => {
    let opt_obj={
      info_arr:[],
      ...inData
    };
    let todo_data=null;
    for(let i=0;i<todo_data_arr.length;i++){
      if(i==popupData.todo_data_row_num){
        todo_data=todo_data_arr[i];
      }
    }
    if(todo_data!=null){
      todo_data.cg_word_custom_arr= opt_obj.info_arr;
      todo_data.a_success_amount = opt_obj.info_arr.length;
      todo_data_arr[popupData.todo_data_row_num]=todo_data;
      myProps.set_todo_data_arr([...todo_data_arr]);
    };
  };

  const get_todo_content_row_tags = () => {
    let row_tags = todo_data_arr.map((item: any, idx: number) => {
      return (
        <TodoContentRow
          key={idx}
          row_num={idx}
          todo_data={item}
          todo_data_arr={todo_data_arr}
          set_todo_data_arr={myProps.set_todo_data_arr}
          delete_todo_content_row={delete_todo_content_row}
          open_select_cg_word_arr_popup={open_select_cg_word_arr_popup}
        ></TodoContentRow>
      );
    });
    return row_tags;
  };

  return (
    <div>
      <div className={Style.sub_title}>
        내용
        {todo_data_arr.length == 0 &&
          <>
            <button className="btn-m btn-yellowish3 ml-1" onClick={() => { open_find_textbook_popup({}); }} >단어학습</button>
            <button className="btn-m btn-yellowish3 ml-1" onClick={() => { open_find_textbook_popup({ par_sort: "word_inside" }); }} >단어학습(in)</button>
          </>
        }
      </div>
      <div className="write_table_small mt-1">
        <table>
          <colgroup>
            <col width={"100px"}></col>
            <col width={"40%"}></col>
            <col width={"100px"}></col>
            <col width={"40%"}></col>
          </colgroup>
          <tbody>
            {get_todo_content_row_tags()}
          </tbody>
        </table>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} y={"0"} >
          {popupData.sort === "find_cg_word" &&
            <FindCGWordPopup
              par_sort={popupData.par_sort}
              listOpt={popupData.listOpt}
              is_req_order={false}
              xcolumn_show_key_arr={["row_view_word_count"]}
              callbackData={callback_find_textbook}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></FindCGWordPopup>
          }
          {popupData.sort === "select_cg_word_arr" &&
            <SelectCGWordArrPopup
              cg_word_arr={popupData.cg_word_arr}
              cg_word_pri_val_arr={popupData.cg_word_pri_val_arr}
              select_cg_word_pri_val_arr={popupData.select_cg_word_pri_val_arr}
              callbackData={callback_select_cg_word_arr}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></SelectCGWordArrPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default TodoContent;